export default "__VITE_ASSET__DlhzJaT9__"